module.exports = __webpack_public_path__ + "img/P56-en.3ea31d1d.png";